import { pipe } from 'ramda';
import { get, keyBy } from 'lodash';
import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';

import { t } from '../../../../../modules/infra/i18n';
import { withBulkUpdateFilters } from '../Filters';
import { isBarberUser } from '../../../../auth/selectors';
import { showNotification } from '../../../../common/helpers/notifications';
import { bulkUpdateShopInventory, bulkUpdateBarberInventory } from '../../actions';

const mapStateToProps = state => ({
  shop: state.auth.shop,
  user: state.auth.user,
  barberUser: state.auth.barberUser,
  isBarberUser: isBarberUser(state),
});

const mapDispatchToProps = {
  bulkUpdateShopInventory,
  bulkUpdateBarberInventory,
};

const attributesToPayload = (userId, shopId, barber, products) => (attrs) => {
  const productIds = Object.keys(attrs);
  const updates = productIds.map((productId) => {
    const product = {
      userId,
      shopId,
      productId,
      quantity: Number(attrs[productId]) - get(products, `[${productId}].inventory`, 0),
      action: 'stockTaking',
    };

    if (barber) {
      product.barberId = barber.id;
    }

    return product;
  });

  return { products: updates };
};

const removeFilteredOutProducts = filteredProducts => ({ products }) => {
  const filteredProductIds = keyBy(filteredProducts, 'assignmentId');
  return { products: products.filter(p => filteredProductIds[p.productId]) };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withBulkUpdateFilters,
  withState('quantities', 'setQuantities', {}),
  withState('submitting', 'setSubmitting', false),
  withHandlers({
    onQtyChange: props => assignmentId => (event) => {
      props.setQuantities((currentQtys) => {
        if (event.target.value) {
          return { ...currentQtys, [assignmentId]: event.target.value };
        }

        const quantitiesCopy = { ...currentQtys };
        delete quantitiesCopy[assignmentId];

        return quantitiesCopy;
      });
    },
    onSubmit: props => async (e) => {
      e.preventDefault();

      props.setSubmitting(true);

      try {
        const [id, submit] = props.isBarberUser
          ? [props.barberUser.id, props.bulkUpdateBarberInventory] : [props.shop, props.bulkUpdateShopInventory];
        const products = props.products.reduce((memo, item) => ({ ...memo, [item.assignmentId]: item }), {});
        const transformAttributes = attributesToPayload(props.user.id, props.shop, props.barberUser, products);
        const handle = pipe(transformAttributes, removeFilteredOutProducts(props.products), submit.bind(null, id));

        await handle(props.quantities);

        props.setSubmitting(false);
        props.close();
        showNotification({
          title: t('common:done'),
          message: t('products:bulk_inventory.inventory_updated_message'),
          level: 'success',
        });
      } catch (error) {
        props.setSubmitting(false);
      }
    },
  }),
);
